import util from "./util";
import Cookies from "universal-cookie";

const newrelic = window.newrelic ? window.newrelic : "";
const _dg_sessionId = window._dg_sessionId ? window._dg_sessionId : "";
const _dg_eReqId = window._dg_eReqId ? window._dg_eReqId : "";

export function logNewrelicNoticeError(errorObject, logType) {
  try {
    let dateTime = new Date().toLocaleString("en-US", { timeZone: "UTC" });
    const cookies = new Cookies();
    let sessionId = cookies.get("digital_ig_session");
    sessionId = sessionId ? sessionId : "trgnsa";
    let channelId = util.getChannelId();
    let logPayload = {
      dateTime: dateTime,
      logType: logType,
      channelId: channelId,
      e2eRequestId: _dg_eReqId,
      url: window.location.href,
      sessionId: sessionId
    };

    if (window.config?.isAcss) {
      logPayload.accountNumber = window?.caseDetails?.accountNumber ?? "";
    }
   
    if (typeof (newrelic) != "undefined" && typeof (newrelic.noticeError) != "undefined") {
      newrelic.noticeError(errorObject, logPayload);
    }

  } catch (ex) { console.log("ex:" + ex); }
}
